import { render, staticRenderFns } from "./BaseInputAutoComplete.vue?vue&type=template&id=1966ba79&"
import script from "./BaseInputAutoComplete.vue?vue&type=script&lang=js&"
export * from "./BaseInputAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports